import {
  NgModule
} from '@angular/core';
import {
  Routes,
  RouterModule
} from '@angular/router';
import {
  DGXXMLRequestValidateComponent
} from './shared/components/dgx-xml-request-validate/dgx-xml-request-validate.component';

import {
  DGXHomeComponent
} from './dgx/dgx-home/dgx-home.component';
import {
  DGXXMLResponseComponent
} from './shared/components/dgx-xml-response/dgx-xml-response.component';

import {
  DGXHTMLResponseComponent
} from './shared/components/dgx-html-response/dgx-html-response.component';
import {
  MauiLayoutComponent
} from './shared/components/layout/maui-layout/maui-layout.component';
import {
  DGXLayoutComponent
} from './shared/components/layout/dgx-layout/dgx-layout.component';
import {
  DataIntegrationToolkitHomeComponent
} from './maui/data-integration-toolkit-home/data-integration-toolkit-home.component';
import {
  DataIntegrationToolkitHomeDuComponent
} from './maui/data-integration-toolkit-home-du/data-integration-toolkit-home-du.component';
import {
  DataIntegrationToolkitHomeFrComponent
} from './maui/data-integration-toolkit-home-fr/data-integration-toolkit-home-fr.component';
import {
  DataIntegrationToolkitHomeItComponent
} from './maui/data-integration-toolkit-home-it/data-integration-toolkit-home-it.component';
import {
  DataIntegrationToolkitHomeJpComponent
} from './maui/data-integration-toolkit-home-jp/data-integration-toolkit-home-jp.component';
import {
  DataIntegrationToolkitHomeNtComponent
} from './maui/data-integration-toolkit-home-nt/data-integration-toolkit-home-nt.component';
import {
  DataIntegrationToolkitHomePoComponent
} from './maui/data-integration-toolkit-home-po/data-integration-toolkit-home-po.component';
import {
  DataIntegrationToolkitHomeSpComponent
} from './maui/data-integration-toolkit-home-sp/data-integration-toolkit-home-sp.component';


const accountModule = () => import('./account/account.module').then(x => x.AccountModule);
const usersModule = () => import('./users/users.module').then(x => x.UsersModule);

//DGX Modules
const profileModule = () => import('./dgx/profile/profile.module').then(x => x.ProfileModule);
const lookupModule = () => import('./dgx/lookup/lookup.module').then(x => x.LookupModule);
const addRegistrationModule = () => import('./dgx/add-registration/add-registration.module').then(x => x.AddRegistrationModule);
const standardizeNameAndAddressModule = () => import('./dgx/standardize-name-and-address/standardize-name-and-address.module').then(x => x.StandardizeNameAndAddressModule);
const listOrdersModule = () => import('./dgx/list-orders/list-orders.module').then(x => x.ListOrdersModule);
const listOrdersV2Module = () => import('./dgx/list-orders-v2/list-orders-v2.module').then(x => x.ListOrdersV2Module);
const preferenceModule = () => import('./dgx/preference/preference.module').then(x => x.PreferenceModule);
const ordersAndInvestigationsModule = () => import('./dgx/orders-and-investigations/orders-and-investigations.module').then(x => x.OrdersAndInvestigationsModule);
const publicRecordsSearchModule = () => import('./dgx/public-records-search/public-records-search.module').then(x => x.PublicRecordsSearchModule);
const publicRecordsDetailsModule = () => import('./dgx/public-records-details/public-records-details.module').then(x => x.PublicRecordsDetailsModule);
const productListModule = () => import('./dgx/product-list/product-list.module').then(x => x.ProductListModule);
const familyTreeModule = () => import('./dgx/family-tree/family-tree.module').then(x => x.FamilyTreeModule);
const getRegistrationListModule = () => import('./dgx/get-registration-list/get-registration-list.module').then(x => x.GetRegistrationListModule);
const headquarterRegistrationListModule = () => import('./dgx/headquarter-registration-list/headquarter-registration-list.module').then(x => x.HeadquarterRegistrationListModule);
const modifyRegistrationModule = () => import('./dgx/modify-registration/modify-registration.module').then(x => x.ModifyRegistrationModule);
const notificationsModule = () => import('./dgx/notifications/notifications.module').then(x => x.NotificationsModule);
const registrationActivityModule = () => import('./dgx/registration-activity/registration-activity.module').then(x => x.RegistrationActivityModule);
const transferRegistrationModule = () => import('./dgx/transfer-registration/transfer-registration.module').then(x => x.TransferRegistrationModule);
const getBaselineInformationModule = () => import('./dgx/get-baseline-information/get-baseline-information.module').then(x => x.GetBaselineInformationModule);
const getNotificationCountModule = () => import('./dgx/get-notification-count/get-notification-count.module').then(x => x.GetNotificationCountModule);

//Maui Modules
const standardizeNameModule = () => import('./maui/locked/standardize-name-and-address/standardize-name-and-address.module').then(x => x.StandardizeNameAndAddressModule);
const orderAnInvestigationInvModule = () => import('./maui/locked/order-an-investigation-inv/order-an-investigation-inv.module').then(x => x.OrderAnInvestigationInvModule);
const testDriveModule = () => import('./maui/locked/test-drive/test-drive.module').then(x => x.TestDriveModule);
const globalTestLibraryModule = () => import('./maui/locked/global-test-library/global-test-library.module').then(x => x.GlobalTestLibraryModule);
const mauiProductPrintPageModule = () => import('./maui/locked/maui-product-print-page/maui-product-print-page.module').then(x => x.MauiProductPrintPageModule);
const technicalDocumentationModule = () => import('./maui/locked/technical-documentation/technical-documentation.module').then(x => x.TechnicalDocumentationModule);
const viewSampleModule = () => import('./maui/unlocked/view-sample/view-sample.module').then(x => x.ViewSampleModule);
const viewDataContentModule = () => import('./maui/unlocked/view-data-content/view-data-content.module').then(x => x.ViewDataContentModule);
const disclaimerHomeModule = () => import('./maui/unlocked/disclaimer-home/disclaimer-home.module').then(x => x.DisclaimerHomeModule);
const solutionsHomeModule = () => import('./maui/unlocked/solutions-home/solutions-home.module').then(x => x.SolutionsHomeModule);
const solutionsHomeDuModule = () => import('./maui/unlocked/solutions-home-du/solutions-home-du.module').then(x => x.SolutionsHomeDuModule);
const solutionsHomeFrModule = () => import('./maui/unlocked/solutions-home-fr/solutions-home-fr.module').then(x => x.SolutionsHomeFrModule);
const solutionsHomeItModule = () => import('./maui/unlocked/solutions-home-it/solutions-home-it.module').then(x => x.SolutionsHomeItModule);
const solutionsHomeJpModule = () => import('./maui/unlocked/solutions-home-jp/solutions-home-jp.module').then(x => x.SolutionsHomeJpModule);
const solutionsHomeNtModule = () => import('./maui/unlocked/solutions-home-nt/solutions-home-nt.module').then(x => x.SolutionsHomeNtModule);
const solutionsHomePoModule = () => import('./maui/unlocked/solutions-home-po/solutions-home-po.module').then(x => x.SolutionsHomePoModule);
const solutionsHomeSpModule = () => import('./maui/unlocked/solutions-home-sp/solutions-home-sp.module').then(x => x.SolutionsHomeSpModule);
const globalDataSolutionsModule = () => import('./maui/unlocked/global-data-solutions/global-data-solutions.module').then(x => x.GlobalDataSolutionsModule);
const productDataSheetModule = () => import('./maui/unlocked/product-data-sheet/product-data-sheet.module').then(x => x.ProductDataSheetModule);
const productDataSheetTechnologyModule = () => import('./maui/locked/product-data-sheet-technology/product-data-sheet-technology.module').then(x => x.ProductDataSheetTechnologyModule);
const dataSolutionsModule = () => import('./maui/unlocked/data-solutions/data-solutions.module').then(x => x.DataSolutionsModule);
const nextStepModule = () => import('./maui/unlocked/next-step/next-step.module').then(x => x.NextStepModule);
const localCountrySolutionsModule = () => import('./maui/unlocked/local-country-solutions/local-country-solutions.module').then(x => x.LocalCountrySolutionsModule);
const localCountrySolutionsHyperlinkModule = () => import('./maui/unlocked/local-country-solutions-hyperlink/local-country-solutions-hyperlink.module').then(x => x.LocalCountrySolutionsHyperlinkModule);
const enterpriseApplicationSolutionsModule = () => import('./maui/unlocked/enterprise-application-solutions/enterprise-application-solutions.module').then(x => x.EnterpriseApplicationSolutionsModule);
const addOnSolutionsModule = () => import('./maui/unlocked/add-on-solutions/add-on-solutions.module').then(x => x.AddOnSolutionsModule);
const addOnSolutionsHyperlinkModule = () => import('./maui/locked/add-on-solutions-hyperlink/add-on-solutions-hyperlink.module').then(x => x.AddOnSolutionsHyperlinkModule);
const newSolutionsModule = () => import('./maui/unlocked/new-solutions/new-solutions.module').then(x => x.NewSolutionsModule);
const newSolutionsHyperlinkModule = () => import('./maui/unlocked/new-solutions-hyperlink/new-solutions-hyperlink.module').then(x => x.NewSolutionsHyperlinkModule);
const alphabeticListingOfSolutionsModule = () => import('./maui/unlocked/alphabetic-listing-of-solutions/alphabetic-listing-of-solutions.module').then(x => x.AlphabeticListingOfSolutionsModule);
const alphabeticListingOfSolutionsHyperlinkModule = () => import('./maui/unlocked/alphabetic-listing-of-solutions-hyperlink/alphabetic-listing-of-solutions-hyperlink.module').then(x => x.AlphabeticListingOfSolutionsHyperlinkModule);
const technologyModule = () => import('./maui/unlocked/technology/technology.module').then(x => x.TechnologyModule);
const technologyduModule = () => import('./maui/unlocked/technology-du/technology-du.module').then(x => x.TechnologyDuModule);
const technologyfrModule = () => import('./maui/unlocked/technology-fr/technology-fr.module').then(x => x.TechnologyFrModule);
const technologyitModule = () => import('./maui/unlocked/technology-it/technology-it.module').then(x => x.TechnologyItModule);
const technologyjpModule = () => import('./maui/unlocked/technology-jp/technology-jp.module').then(x => x.TechnologyJpModule);
const technologyntModule = () => import('./maui/unlocked/technology-nt/technology-nt.module').then(x => x.TechnologyNtModule);
const technologypoModule = () => import('./maui/unlocked/technology-po/technology-po.module').then(x => x.TechnologyPoModule);
const technologyspModule = () => import('./maui/unlocked/technology-sp/technology-sp.module').then(x => x.TechnologySpModule);
const toolkitDownloadsModule = () => import('./maui/locked/toolkit-downloads/toolkit-downloads.module').then(x => x.ToolkitDownloadsModule);
const wsdlProductDataSheetModule = () => import('./maui/locked/wsdl-product-data-sheet/wsdl-product-data-sheet.module').then(x => x.WSDLProductDataSheetModule);
const xmlProductDataSheetModule = () => import('./maui/locked/xml-product-data-sheet/xml-product-data-sheet.module').then(x => x.XMLProductDataSheetModule);
const tDproductDataSheetModule = () => import('./maui/locked/td-product-data-sheet/td-product-data-sheet.module').then(x => x.TDProductDataSheetModule);
const tDproductDataSheetHyperlinksModule = () => import('./maui/locked/td-product-data-sheet-hyperlinks/td-product-data-sheet-hyperlinks.module').then(x => x.TDProductDataSheetHyperlinksModule);
const javaProductDataSheetModule = () => import('./maui/locked/java-product-data-sheet/java-product-data-sheet.module').then(x => x.JavaProductDataSheetModule);
const cOMProductDataSheetModule = () => import('./maui/locked/com-product-data-sheet/com-product-data-sheet.module').then(x => x.COMProductDataSheetModule);
const implementModule = () => import('./maui/locked/implement/implement.module').then(x => x.ImplementModule);
const implementHyperlinkModule = () => import('./maui/locked/implement-hyperlink/implement-hyperlink.module').then(x => x.ImplementHyperlinkModule);
const newProductsModule = () => import('./maui/locked/new-products/new-products.module').then(x => x.NewProductsModule);
const productsModule = () => import('./maui/locked/products/products.module').then(x => x.ProductsModule);
const productsHyperlinkModule = () => import('./maui/locked/products-hyperlink/products-hyperlink.module').then(x => x.ProductsHyperlinkModule);
const modulesModule = () => import('./maui/locked/modules/modules.module').then(x => x.ModulesModule);
const modulesHyperlinkModule = () => import('./maui/locked/modules-hyperlink/modules-hyperlink.module').then(x => x.ModulesHyperlinkModule);
const alliancesModule = () => import('./maui/locked/alliances/alliances.module').then(x => x.AlliancesModule);
const messagesModule = () => import('./maui/locked/messages/messages.module').then(x => x.MessagesModule);

const dataLinksModule = () => import('./maui/locked/data-links/data-links.module').then(x => x.DataLinksModule);
const dataLinksHyperLinksModule = () => import('./maui/locked/data-links-hyperlinks/data-links-hyperlinks.module').then(x => x.DataLinksHyperLinksModule);
const toolkitWhitePapersModule = () => import('./maui/locked/toolkit-white-papers/toolkit-white-papers.module').then(x => x.ToolkitWhitePapersModule);

const sslCertificateRenewalProcedureModule = () => import('./maui/locked/ssl-certificate-renewal-procedure/ssl-certificate-renewal-procedure.module').then(x => x.SslCertificateRenewalProcedureModule);
const unixInstructionsModule = () => import('./maui/locked/unix-instructions/unix-instructions.module').then(x => x.UnixInstructionsModule);
const primaryIntermediateModule = () => import('./maui/locked/primary-intermediate/primary-intermediate.module').then(x => x.PrimaryIntermediateModule);
const emailUsModule = () => import('./maui/unlocked/email-us/email-us.module').then(x => x.EmailUsModule);
const contactUsModule = () => import('./maui/unlocked/contact-us/contact-us.module').then(x => x.ContactUsModule);
const newToolkitUrlModule = () => import('./maui/locked/new-toolkit-url/new-toolkit-url.module').then(x => x.NewToolkitUrlModule);
const releaseUpdateModule = () => import('./maui/unlocked/release-update/release-update.module').then(x => x.ReleaseUpdateModule);

const toolkitReleaseNotesHyperlinkModule = () => import('./maui/unlocked/toolkit-release-notes-hyperlink/toolkit-release-notes-hyperlink.module').then(x => x.ToolkitReleaseNotesHyperlinkModule);
const rightboxFaqsModule = () => import('./maui/locked/rightbox-faqs/rightbox-faqs.module').then(x => x.RightboxFaqsModule);
const supportModule = () => import('./maui/unlocked/support/support.module').then(x => x.SupportModule);
const supportduModule = () => import('./maui/unlocked/support-du/support-du.module').then(x => x.SupportDuModule);
const supportfrModule = () => import('./maui/unlocked/support-fr/support-fr.module').then(x => x.SupportFrModule);
const supportitModule = () => import('./maui/unlocked/support-it/support-it.module').then(x => x.SupportItModule);
const supportjpModule = () => import('./maui/unlocked/support-jp/support-jp.module').then(x => x.SupportJpModule);
const supportpoModule = () => import('./maui/unlocked/support-po/support-po.module').then(x => x.SupportPoModule);
const supportspModule = () => import('./maui/unlocked/support-sp/support-sp.module').then(x => x.SupportSpModule);
const supportntModule = () => import('./maui/unlocked/support-nt/support-nt.module').then(x => x.SupportNtModule);
const faqsModule = () => import('./maui/locked/faqs/faqs.module').then(x => x.FaqsModule);
const faqsHyperlinkModule = () => import('./maui/locked/faqs-hyperlink/faqs-hyperlink.module').then(x => x.FaqsHyperlinkModule);
const xmlRsltModule = () => import('./maui/locked/xml-rslt/xml-rslt.module').then(x => x.XmlRsltModule);
const custFdbkModule = () => import('./maui/locked/cust-fdbk/cust-fdbk.module').then(x => x.CustFdbkModule);
const tipsAndTechniquesModule = () => import('./maui/locked/tips-and-techniques/tips-and-techniques.module').then(x => x.TipsAndTechniquesModule);
const techNotes1Module = () => import('./maui/locked/tech-notes1/tech-notes1.module').then(x => x.TechNotes1Module);
const techNotes2Module = () => import('./maui/locked/tech-notes2/tech-notes2.module').then(x => x.TechNotes2Module);
const techNotes3Module = () => import('./maui/locked/tech-notes3/tech-notes3.module').then(x => x.TechNotes3Module);
const nameAddressStandardizationFaqsModule = () => import('./maui/locked/name-address-standardization-faqs/name-address-standardization-faqs.module').then(x => x.NameAddressStandardizationFaqsModule);
const companySearchModule = () => import('./maui/locked/company-search/company-search.module').then(x => x.CompanySearchModule);
const searchResultsModule = () => import('./maui/locked/search-results/search-results.module').then(x => x.SearchResultsModule);
const searchResultsDunsPhoneModule = () => import('./maui/locked/search-results-duns-phone/search-results-duns-phone.module').then(x => x.SearchResultsDunsPhoneModule);
const orderAnInvestigationModule = () => import('./maui/locked/order-an-investigation/order-an-investigation.module').then(x => x.OrderAnInvestigationModule);
const orderAnInvestigationConfModule = () => import('./maui/locked/order-an-investigation-conf/order-an-investigation-conf.module').then(x => x.OrderAnInvestigationConfModule);
const mauiProductPageModule = () => import('./maui/locked/maui-product-page/maui-product-page.module').then(x => x.MauiProductPageModule);
const languageListPageModule = () => import('./maui/locked/language-list-page/language-list-page.module').then(x => x.LanguageListPageModule);
const YourArchiveRoutingModule = () => import('./maui/locked/your-archive/your-archive.module').then(x => x.YourArchiveModule);
const utilizingTheToolkitModule = () => import('./maui/locked/utilizing-the-toolkit/utilizing-the-toolkit.module').then(x => x.UtilizingTheToolkitModule);
const toolkitUIGuideModule = () => import('./maui/unlocked/toolkit-ui-guide/toolkit-ui-guide.module').then(x => x.ToolkitUIGuideModule);
const toolkitProcessFlowModule = () => import('./maui/locked/toolkit-process-flow/toolkit-process-flow.module').then(x => x.ToolkitProcessFlowModule);

const loginPageModule = () => import('./maui/locked/login-page/login-page.module').then(x => x.LoginPageModule);

const signonRecordsModule = () => import('./maui/locked/signon-records/signon-records.module').then(x => x.SignonRecordsModule);

const lookupOrSearchModule = () => import('./maui/locked/lookup-or-search/lookup-or-search.module').then(x => x.LookupOrSearchModule);

const confidenceSearchesModule = () => import('./maui/locked/confidence-searches/confidence-searches.module').then(x => x.ConfidenceSearchesModule);

const stateModule = () => import('./maui/locked/state/state.module').then(x => x.StateModule);

const interpretationTablesModule = () => import('./maui/locked/interpretation-tables/interpretation-tables.module').then(x => x.InterpretationTablesModule);

const xmlDocumentationModule = () => import('./maui/locked/xml-documentation/xml-documentation.module').then(x => x.XmlDocumentationModule);

const germanReasonCodesModule = () => import('./maui/locked/german-reason-codes/german-reason-codes.module').then(x => x.GermanReasonCodesModule);

const canadianProvisionalCodeValuesModule = () => import('./maui/locked/canadian-provisional-code-values/canadian-provisional-code-values.module').then(x => x.CanadianProvisionalCodeValuesModule);

const countryCodeValuesModule = () => import('./maui/locked/country-code-values/country-code-values.module').then(x => x.CountryCodeValuesModule);

const viewRequestOrResponseModule = () => import('./maui/locked/view-request-or-response/view-request-or-response.module').then(x => x.ViewRequestOrResponseModule);

const chooseOrConfirmCandidateModule = () => import('./maui/locked/choose-or-confirm-candidate/choose-or-confirm-candidate.module').then(x => x.ChooseOrConfirmCandidateModule);

const requestingAvailableProductsModule = () => import('./maui/locked/requesting-available-products/requesting-available-products.module').then(x => x.RequestingAvailableProductsModule);

const productLanguageModule = () => import('./maui/locked/product-language/product-language.module').then(x => x.ProductLanguageModule);

const investigationsModule = () => import('./maui/locked/investigations/investigations.module').then(x => x.InvestigationsModule);

const productListRecordsModule = () => import('./maui/locked/product-list-records/product-list-records.module').then(x => x.ProductListRecordsModule);

const viewProductRequestResponseModule = () => import('./maui/locked/view-product-request-response/view-product-request-response.module').then(x => x.ViewProductRequestResponseModule);

const dataRecordModule = () => import('./maui/locked/data-record/data-record.module').then(x => x.DataRecordModule);

const orderAProductModule = () => import('./maui/locked/order-a-product/order-a-product.module').then(x => x.OrderAProductModule);

const usPublicRecordSearchModule = () => import('./maui/locked/us-public-record-search/us-public-record-search.module').then(x => x.UsPublicRecordSearchModule);

const publicRecordSearchModule = () => import('./maui/locked/public-record-search/public-record-search.module').then(x => x.PublicRecordSearchModule);

const localBusinessIdentifiersModule = () => import('./maui/locked/local-business-identifiers/local-business-identifiers.module').then(x => x.LocalBusinessIdentifiersModule);

const publicRecordFilingListModule = () => import('./maui/locked/public-record-filing-list/public-record-filing-list.module').then(x => x.PublicRecordFilingListModule);

const requestUsageInformationModule = () => import('./maui/locked/request-usage-information/request-usage-information.module').then(x => x.RequestUsageInformationModule);

const listOrdersToolkitModule = () => import('./maui/locked/list-orders-toolkit/list-orders-toolkit.module').then(x => x.ListOrdersToolkitModule);



const nameAddressStdModule = () => import('./maui/locked/name-address-std/name-address-std.module').then(x => x.NameAddressStdModule);

const dataRecordsModule = () => import('./maui/locked/data-records/data-records.module').then(x => x.DataRecordsModule);

const seeExampleModule = () => import('./maui/locked/see-example/see-example.module').then(x => x.SeeExampleModule);

const toolkitIntranetSolutionsModule = () => import('./maui/locked/toolkit-intranet-solutions/toolkit-intranet-solutions.module').then(x => x.ToolkitIntranetSolutionsModule);

const localReuseDatabasePluginModule = () => import('./maui/locked/local-reuse-database-plugin/local-reuse-database-plugin.module').then(x => x.LocalReuseDatabasePluginModule);

const softwareDownloadModule = () => import('./maui/locked/software-download/software-download.module').then(x => x.SoftwareDownloadModule);

const configurationScenariosModule = () => import('./maui/locked/configuration-scenarios/configuration-scenarios.module').then(x => x.ConfigurationScenariosModule);

const dataIntegrationIntranetPropMethodsModule = () => import('./maui/locked/data-integration-intranet-prop-methods/data-integration-intranet-prop-methods.module').then(x => x.DataIntegrationIntranetPropMethodsModule);

const releaseNotesModule = () => import('./maui/locked/release-notes/release-notes.module').then(x => x.ReleaseNotesModule);

const serviceMonitorModule = () => import('./maui/locked/service-monitor/service-monitor.module').then(x => x.ServiceMonitorModule);


const contactUsDgxModule = () => import('./maui/unlocked/contact-us-dgx/contact-us-dgx.module').then(x => x.ContactUsDgxModule);

const customerFeedbackDgxModule = () => import('./maui/unlocked/customer-feedback-dgx/customer-feedback-dgx.module').then(x => x.CustomerFeedbackDgxModule);

const toolsForDevelopersModule = () => import('./maui/locked/tools-for-developers/tools-for-developers.module').then(x => x.ToolsForDevelopersModule);

const toolkitOverviewModule = () => import('./maui/unlocked/toolkit-overview/toolkit-overview.module').then(x => x.ToolkitOverviewModule);

const frequentlyAskedQuestionsModule = () => import('./maui/unlocked/frequently-asked-questions/frequently-asked-questions.module').then(x => x.FrequentlyAskedQuestionsModule);

const faqs1Module = () => import('./maui/unlocked/faqs1/faqs1.module').then(x => x.Faqs1Module);

const faqs2Module = () => import('./maui/unlocked/faqs2/faqs2.module').then(x => x.Faqs2Module);

const faqs3Module = () => import('./maui/unlocked/faqs3/faqs3.module').then(x => x.Faqs3Module);

const faqs4Module = () => import('./maui/unlocked/faqs4/faqs4.module').then(x => x.Faqs4Module);

const faqs5Module = () => import('./maui/unlocked/faqs5/faqs5.module').then(x => x.Faqs5Module);

const serviceLevelDefinitionsModule = () => import('./maui/unlocked/service-level-definitions/service-level-definitions.module').then(x => x.ServiceLevelDefinitionsModule);
const sbriListModule = () => import('./maui/locked/sbri-list/sbri-list.module').then(x => x.SBRIListModule);
const orderCorporateHierarchyModule = () => import('./maui/locked/order-corporate-hierarchy/order-corporate-hierarchy.module').then(x => x.OrderCorporateHierarchyModule);

const basicHierarchyModule = () => import('./maui/locked/basic-hierarchy/basic-hierarchy.module').then(x => x.BasicHierarchyModule);
const enhancedHierarchyModule = () => import('./maui/locked/enhanced-hierarchy/enhanced-hierarchy.module').then(x => x.EnhancedHierarchyModule);

const routes: Routes = [
  // Maui layouts goes here
  {
    path: '',
    component: MauiLayoutComponent,
    children: [{
        path: '',
        component: DataIntegrationToolkitHomeComponent
      },
      {
        path: 'data-integration-toolkit-home',
        component: DataIntegrationToolkitHomeComponent
      },
      {
        path: 'data-integration-toolkit-home-du',
        component: DataIntegrationToolkitHomeDuComponent
      },
      {
        path: 'data-integration-toolkit-home-fr',
        component: DataIntegrationToolkitHomeFrComponent
      },
      {
        path: 'data-integration-toolkit-home-it',
        component: DataIntegrationToolkitHomeItComponent
      },
      {
        path: 'data-integration-toolkit-home-jp',
        component: DataIntegrationToolkitHomeJpComponent
      },
      {
        path: 'data-integration-toolkit-home-nt',
        component: DataIntegrationToolkitHomeNtComponent
      },
      {
        path: 'data-integration-toolkit-home-po',
        component: DataIntegrationToolkitHomePoComponent
      },
      {
        path: 'data-integration-toolkit-home-sp',
        component: DataIntegrationToolkitHomeSpComponent
      },
      {
        path: 'unlocked/view-sample/:productsAndReports',
        loadChildren: viewSampleModule
      },
      {
        path: 'unlocked/view-data-content/:productsAndReports',
        loadChildren: viewDataContentModule
      },
	  {
        path: 'unlocked/disclaimer-home',
        loadChildren: disclaimerHomeModule
      },
      {
        path: 'unlocked/solutions-home',
        loadChildren: solutionsHomeModule
      },
      {
        path: 'unlocked/solutions-home-du',
        loadChildren: solutionsHomeDuModule
      },
      {
        path: 'unlocked/solutions-home-fr',
        loadChildren: solutionsHomeFrModule
      },
      {
        path: 'unlocked/solutions-home-it',
        loadChildren: solutionsHomeItModule
      },
      {
        path: 'unlocked/solutions-home-jp',
        loadChildren: solutionsHomeJpModule
      },
      {
        path: 'unlocked/solutions-home-nt',
        loadChildren: solutionsHomeNtModule
      },
      {
        path: 'unlocked/solutions-home-po',
        loadChildren: solutionsHomePoModule
      },
      {
        path: 'unlocked/solutions-home-sp',
        loadChildren: solutionsHomeSpModule
      },
      {
        path: 'unlocked/global-data-solutions',
        loadChildren: globalDataSolutionsModule
      },
      {
        path: 'unlocked/data-solutions/:type',
        loadChildren: dataSolutionsModule
      },
      {

        path: 'locked/toolkit-white-papers',

        loadChildren: toolkitWhitePapersModule

      },
      {
        path: 'unlocked/next-step',
        loadChildren: nextStepModule
      },
      {
        path: 'unlocked/local-country-solutions',
        loadChildren: localCountrySolutionsModule
      },
      {
        path: 'unlocked/local-country-solutions-hyperlink',
        loadChildren: localCountrySolutionsHyperlinkModule
      },
      {
        path: 'unlocked/enterprise-application-solutions',
        loadChildren: enterpriseApplicationSolutionsModule
      },
      {
        path: 'unlocked/add-on-solutions',
        loadChildren: addOnSolutionsModule
      },
      {
        path: 'locked/add-on-solutions-hyperlink',
        loadChildren: addOnSolutionsHyperlinkModule
      },
      {
        path: 'unlocked/new-solutions',
        loadChildren: newSolutionsModule
      },
      {
        path: 'unlocked/new-solutions-hyperlink',
        loadChildren: newSolutionsHyperlinkModule
      },
      {
        path: 'unlocked/alphabetic-listing-of-solutions',
        loadChildren: alphabeticListingOfSolutionsModule
      },
      {
        path: 'unlocked/alphabetic-listing-of-solutions-hyperlink',
        loadChildren: alphabeticListingOfSolutionsHyperlinkModule
      },
      {
        path: 'unlocked/technology',
        loadChildren: technologyModule
      },
      {
        path: 'unlocked/technology-du',
        loadChildren: technologyduModule
      },
      {
        path: 'unlocked/technology-fr',
        loadChildren: technologyfrModule
      },
      {
        path: 'unlocked/technology-it',
        loadChildren: technologyitModule
      },
      {
        path: 'unlocked/technology-jp',
        loadChildren: technologyjpModule
      },
      {
        path: 'unlocked/technology-nt',
        loadChildren: technologyntModule
      },
      {
        path: 'unlocked/technology-po',
        loadChildren: technologypoModule
      },
      {
        path: 'unlocked/technology-sp',
        loadChildren: technologyspModule
      },

      {

        path: 'locked/new-toolkit-url',

        loadChildren: newToolkitUrlModule

      },

      {

        path: 'locked/rightbox-faqs',

        loadChildren: rightboxFaqsModule

      },
      {

        path: 'unlocked/release-update',

        loadChildren: releaseUpdateModule

      },

      {

        path: 'unlocked/toolkit-release-notes-hyperlink',

        loadChildren: toolkitReleaseNotesHyperlinkModule

      },
      {
        path: 'locked/wsdl-product-data-sheet',
        loadChildren: wsdlProductDataSheetModule
      },
      {
        path: 'locked/xml-product-data-sheet',
        loadChildren: xmlProductDataSheetModule
      },
      {
        path: 'locked/java-product-data-sheet',
        loadChildren: javaProductDataSheetModule
      },
      {
        path: 'locked/com-product-data-sheet',
        loadChildren: cOMProductDataSheetModule
      },
      {
        path: 'locked/toolkit-downloads/:type',
        loadChildren: toolkitDownloadsModule
      },
      {
        path: 'locked/td-product-data-sheet-hyperlinks',
        loadChildren: tDproductDataSheetHyperlinksModule
      },
      {
        path: 'locked/implement',
        loadChildren: implementModule
      },
      {
        path: 'locked/implement-hyperlink',
        loadChildren: implementHyperlinkModule
      },
      {
        path: 'locked/products/:type',
        loadChildren: productsModule
      },
      {
        path: 'locked/new-products',
        loadChildren: newProductsModule
      },
      {
        path: 'locked/modules',
        loadChildren: modulesModule
      },
      {
        path: 'locked/modules-hyperlink',
        loadChildren: modulesHyperlinkModule
      },
      {
        path: 'locked/alliances',
        loadChildren: alliancesModule
      },
      {
        path: 'locked/messages',
        loadChildren: messagesModule
      },
      {
        path: 'locked/products-hyperlink',
        loadChildren: productsHyperlinkModule
      },
      {
        path: 'locked/data-links',
        loadChildren: dataLinksModule
      },
      {
        path: 'locked/data-links-hyperlinks',
        loadChildren: dataLinksHyperLinksModule
      },

      {
        path: 'locked/ssl-certificate-renewal-procedure',
        loadChildren: sslCertificateRenewalProcedureModule
      },
      {
        path: 'locked/company-search',
        loadChildren: companySearchModule
      },
      {
        path: 'locked/search-results',
        loadChildren: searchResultsModule
      },
      {
        path: 'locked/search-results-duns-phone',
        loadChildren: searchResultsDunsPhoneModule
      },
      {
        path: 'locked/order-an-investigation',
        loadChildren: orderAnInvestigationModule
      },
      {
        path: 'locked/order-an-investigation-conf',
        loadChildren: orderAnInvestigationConfModule
      },
      {
        path: 'locked/order-an-investigation-inv',
        loadChildren: orderAnInvestigationInvModule
      },
      {
        path: 'locked/maui-product-page',
        loadChildren: mauiProductPageModule
      },
      {
        path: 'locked/language-list-page',
        loadChildren: languageListPageModule
      },
      {
        path: 'locked/faqs/:page',
        loadChildren: faqsModule
      },
      {
        path: 'locked/sbri-list',
        loadChildren: sbriListModule
      },
      {
        path: 'unlocked/support',
        loadChildren: supportModule
      },
      {
        path: 'unlocked/support-du',
        loadChildren: supportduModule
      },
      {
        path: 'unlocked/support-fr',
        loadChildren: supportfrModule
      },
      {
        path: 'unlocked/support-it',
        loadChildren: supportitModule
      },
      {
        path: 'unlocked/support-jp',
        loadChildren: supportjpModule
      },
      {
        path: 'unlocked/support-po',
        loadChildren: supportpoModule
      },
      {
        path: 'unlocked/support-sp',
        loadChildren: supportspModule
      },
      {
        path: 'unlocked/support-nt',
        loadChildren: supportntModule
      },
      {
        path: 'locked/faqs-hyperlink',
        loadChildren: faqsHyperlinkModule
      },
      {
        path: 'locked/xml-rslt',
        loadChildren: xmlRsltModule
      },
      {
        path: 'locked/cust-fdbk',
        loadChildren: custFdbkModule
      },
      {
        path: 'locked/tips-and-techniques',
        loadChildren: tipsAndTechniquesModule
      },
      {
        path: 'locked/tech-notes1',
        loadChildren: techNotes1Module
      },
      {
        path: 'locked/tech-notes2',
        loadChildren: techNotes2Module
      },
      {
        path: 'locked/tech-notes3',
        loadChildren: techNotes3Module
      },
      {
        path: 'locked/name-address-standardization-faqs',
        loadChildren: nameAddressStandardizationFaqsModule
      },
      {
        path: 'locked/toolkit-downloads/:type',
        loadChildren: toolkitDownloadsModule
      },
      {
        path: 'users',
        loadChildren: usersModule
      },
      {
        path: 'account',
        loadChildren: accountModule
      },
      {

        path: 'locked/utilizing-the-toolkit',

        loadChildren: utilizingTheToolkitModule

      },

      {

        path: 'locked/toolkit-process-flow',

        loadChildren: toolkitProcessFlowModule

      },

      {

        path: 'locked/login-page',

        loadChildren: loginPageModule

      },

      {

        path: 'locked/signon-records',

        loadChildren: signonRecordsModule

      },

      {

        path: 'locked/lookup-or-search',

        loadChildren: lookupOrSearchModule

      },

      {

        path: 'locked/confidence-searches',

        loadChildren: confidenceSearchesModule

      },

      {

        path: 'locked/state',

        loadChildren: stateModule

      },

      {

        path: 'locked/interpretation-tables',

        loadChildren: interpretationTablesModule

      },

      {

        path: 'locked/xml-documentation',

        loadChildren: xmlDocumentationModule

      },

      {

        path: 'locked/canadian-provisional-code-values',

        loadChildren: canadianProvisionalCodeValuesModule

      },

      {

        path: 'locked/country-code-values',

        loadChildren: countryCodeValuesModule

      },

      {

        path: 'locked/view-request-or-response',

        loadChildren: viewRequestOrResponseModule

      },

      {

        path: 'locked/choose-or-confirm-candidate',

        loadChildren: chooseOrConfirmCandidateModule

      },

      {

        path: 'locked/requesting-available-products',

        loadChildren: requestingAvailableProductsModule

      },

      {

        path: 'locked/product-language',

        loadChildren: productLanguageModule

      },

      {

        path: 'locked/investigations',

        loadChildren: investigationsModule

      },

      {

        path: 'locked/product-list-records',

        loadChildren: productListRecordsModule

      },

      {

        path: 'locked/view-product-request-response',

        loadChildren: viewProductRequestResponseModule

      },

      {

        path: 'locked/data-record',

        loadChildren: dataRecordModule

      },

      {

        path: 'locked/order-a-product',

        loadChildren: orderAProductModule

      }

      ,

      {

        path: 'locked/us-public-record-search',

        loadChildren: usPublicRecordSearchModule

      },

      {

        path: 'locked/public-record-search',

        loadChildren: publicRecordSearchModule

      },

      {

        path: 'locked/german-reason-codes',

        loadChildren: germanReasonCodesModule

      },

      {

        path: 'locked/local-business-identifiers',

        loadChildren: localBusinessIdentifiersModule

      },

      {

        path: 'locked/public-record-filing-list',

        loadChildren: publicRecordFilingListModule

      },

      {

        path: 'locked/request-usage-information',

        loadChildren: requestUsageInformationModule

      },

      {

        path: 'locked/list-orders-toolkit',

        loadChildren: listOrdersToolkitModule

      },

      {

        path: 'locked/name-address-std',

        loadChildren: nameAddressStdModule

      },

      {

        path: 'locked/data-records',

        loadChildren: dataRecordsModule

      },

      {

        path: 'locked/see-example',

        loadChildren: seeExampleModule

      },

      {

        path: 'locked/toolkit-intranet-solutions',

        loadChildren: toolkitIntranetSolutionsModule

      },

      {

        path: 'locked/local-reuse-database-plugin',

        loadChildren: localReuseDatabasePluginModule

      },

      {

        path: 'locked/software-download',

        loadChildren: softwareDownloadModule

      },

      {

        path: 'locked/configuration-scenarios',

        loadChildren: configurationScenariosModule

      },

      {

        path: 'locked/data-integration-intranet-prop-methods',

        loadChildren: dataIntegrationIntranetPropMethodsModule

      },

      {

        path: 'locked/release-notes',

        loadChildren: releaseNotesModule

      },

      {

        path: 'locked/service-monitor',

        loadChildren: serviceMonitorModule

      },
      {
        path: 'locked/tools-for-developers',
        loadChildren: toolsForDevelopersModule
      },
      {
        path: 'unlocked/contact-us-dgx',
        loadChildren: contactUsDgxModule
      },
      {
        path: 'unlocked/customer-feedback-dgx',
        loadChildren: customerFeedbackDgxModule
      },
      {
        path: 'locked/tools-for-developers',
        loadChildren: toolsForDevelopersModule
      },
      {

        path: 'unlocked/toolkit-overview',

        loadChildren: toolkitOverviewModule

      },

      {

        path: 'unlocked/frequently-asked-questions',

        loadChildren: frequentlyAskedQuestionsModule

      },

      {

        path: 'unlocked/faqs3',

        loadChildren: faqs3Module

      },

      {

        path: 'unlocked/faqs4',

        loadChildren: faqs4Module

      },

      {

        path: 'unlocked/faqs1',

        loadChildren: faqs1Module

      },

      {

        path: 'unlocked/faqs2',

        loadChildren: faqs2Module

      },

      {

        path: 'unlocked/faqs5',

        loadChildren: faqs5Module

      },

      {

        path: 'unlocked/service-level-definitions/:type',

        loadChildren: serviceLevelDefinitionsModule

      },
      {
        path: 'locked/order-corporate-hierarchy',
        loadChildren: orderCorporateHierarchyModule
      },
      {

        path: 'locked/basic-hierarchy',

        loadChildren: basicHierarchyModule

      },

      {

        path: 'locked/enhanced-hierarchy',

        loadChildren: enhancedHierarchyModule

      },
      {
        path: 'locked/your-archive',
        loadChildren: YourArchiveRoutingModule
      },
      {

        path: 'locked/technical-documentation',
        loadChildren: technicalDocumentationModule

      },
      {
        path: 'locked/maui-product-print-page',
        loadChildren: mauiProductPrintPageModule
      },
      {
        path: 'locked/test-drive',
        loadChildren: testDriveModule
      },
      {
        path: 'locked/global-test-library',
        loadChildren: globalTestLibraryModule
      },
      {
        path: 'locked/standardize-name-and-address',
        loadChildren: standardizeNameModule
      }
    ]
  },

  // DGX layouts goes here
  {
    path: '',
    component: DGXLayoutComponent,
    children: [{
        path: '',
        component: DGXHomeComponent
      },
	  {
        path: 'access/demo',
        component: DGXHomeComponent
      },
	  {
        path: 'access/demo/',
        component: DGXHomeComponent
      },
      {
        path: 'access/demo/dgx-home',
        component: DGXHomeComponent
      },
      {
        path: 'access/demo/profile',
        loadChildren: profileModule
      },
      {
        path: 'access/demo/lookup',
        loadChildren: lookupModule

      },
      {
        path: 'access/demo/standardize-name-and-address',
        loadChildren: standardizeNameAndAddressModule

      },
      {
        path: 'access/demo/list-orders',
        loadChildren: listOrdersModule
      },
      {
        path: 'access/demo/list-orders-v2',
        loadChildren: listOrdersV2Module
      },
      {
        path: 'access/demo/preference',
        loadChildren: preferenceModule
      },
      {
        path: 'access/demo/add-registration',
        loadChildren: addRegistrationModule
      },
      {
        path: 'access/demo/orders-and-investigations',
        loadChildren: ordersAndInvestigationsModule
      },
      {
        path: 'access/demo/public-records-search',
        loadChildren: publicRecordsSearchModule
      },
      {
        path: 'access/demo/public-records-details',
        loadChildren: publicRecordsDetailsModule
      },
      {
        path: 'access/demo/dgx-xml-request-validate',
        component: DGXXMLRequestValidateComponent
      },
      {
        path: 'access/demo/dgx-xml-response',
        component: DGXXMLResponseComponent
      },
      {
        path: 'access/demo/dgx-html-response',
        component: DGXHTMLResponseComponent
      },
      {
        path: 'access/demo/product-list',
        loadChildren: productListModule
      },
      {
        path: 'access/demo/family-tree',
        loadChildren: familyTreeModule
      },
      {
        path: 'access/demo/headquarter-registration-list',
        loadChildren: headquarterRegistrationListModule
      },
      {
        path: 'access/demo/get-registration-list',
        loadChildren: getRegistrationListModule
      },
      {
        path: 'access/demo/registration-activity',
        loadChildren: registrationActivityModule
      },
      {
        path: 'access/demo/notifications',
        loadChildren: notificationsModule
      },
      {
        path: 'access/demo/modify-registration',
        loadChildren: modifyRegistrationModule
      },
      {
        path: 'access/demo/transfer-registration',
        loadChildren: transferRegistrationModule
      },
      {
        path: 'access/demo/get-baseline-information',
        loadChildren: getBaselineInformationModule
      },
      {
        path: 'access/demo/get-notification-count',
        loadChildren: getNotificationCountModule
      }
    ]
  },


  //No layouts
  {
    path: 'unlocked/toolkit-ui-guide',
    loadChildren: toolkitUIGuideModule
  },
  {
    path: 'unlocked/product-data-sheet/:productsAndReports',
    loadChildren: productDataSheetModule
  },
  {
    path: 'locked/product-data-sheet-technology/:productsAndReports',
    loadChildren: productDataSheetTechnologyModule
  },
  {
    path: 'locked/td-product-data-sheet/:products',
    loadChildren: tDproductDataSheetModule
  },
  {
    path: 'locked/unix-instructions',
    loadChildren: unixInstructionsModule
  },
  {
    path: 'locked/primary-intermediate',
    loadChildren: primaryIntermediateModule
  },
  {
    path: 'unlocked/email-us',
    loadChildren: emailUsModule
  },
  {
    path: 'unlocked/contact-us',
    loadChildren: contactUsModule
  },

  // otherwise redirect to home
  {
    path: '**',
    redirectTo: ''
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    enableTracing: false,
    scrollPositionRestoration: 'top'
})],
  exports: [RouterModule]
})
export class AppRoutingModule {}
